export const enResetPassword = {
  //text
  SC52title: 'Reset password',
  SC52heading1: 'A new password will be set,',
  SC52heading2: 'So please create a password with at least 8 digits, including both single-byte alphanumericals and numbers.',
  SC52typeAgain: 'Type it again.',
  SC52heading: 'Enter your new password',
  SC52notice: 'Enter the password with at least 8 digits, including both single-byte alphanumericals and numbers',
}
